
import { routePoweredByOabat } from "@/helpers/routing"
export default {
    name: "JobPoweredByOabat",
    props: {
        light: {
            type: Boolean,
            default: false,
        },
        imageLoading: {
            type: String,
            default: "eager",
            validator: (val) => ["lazy", "eager"].includes(val),
        },
    },
    data: () => ({
        routePoweredByOabat,
    }),
    computed: {
        oabatLogo() {
            return this.light
                ? require("@/assets/images/logos/logo-large.svg")
                : require("@/assets/images/logos/logo-white.svg")
        },
    },
}
